// @ts-check
import { gql, useQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '~/design-system';
import Notification from '../Notification';
import CompletedImports from './Completed/Completed';
import FailedImports from './Failed/Failed';
import ImportTabbedMenu from './ImportTabbedMenu';
import InProgressImports from './InProgress/InProgress';

export default function ImportsOverview(props) {
  const { status } = useParams();

  /** @type {[import('../../Notification').Notification | undefined, React.Dispatch<React.SetStateAction<import('../../Notification').Notification | undefined>>]} */
  const [notification, setNotification] = React.useState();

  return (
    <React.Fragment>
      <Box sx={{ maxWidth: '900px', margin: '0 auto' }}>
        <ImportTabbedMenu tab={status} {...props} />
        {status === 'completed' && <CompletedImports />}
        {/* These pages have the ability to delete and need to be able to trigger a refetch of tabs */}
        {status === 'failed' && <FailedImports refetch={props.refetch} />}
        {status === 'inProgress' && (
          <InProgressImports refetch={props.refetch} />
        )}
      </Box>

      {notification && (
        <Notification
          onClose={() => setNotification(undefined)}
          message={notification.message}
          // aLinkData={notification.aLinkData}
          variant={notification.success ? 'success' : 'error'}
        />
      )}
    </React.Fragment>
  );
}

export function useImportsOverview({ workspaceId }) {
  const { data, loading, refetch } = useQuery(query, {
    variables: { workspaceId },
  });

  return {
    loading,
    refetch,
    inProgressCount: data?.workspace?.inProgress?.totalCount,
    completedCount: data?.workspace?.completed?.totalCount,
    failedCount: data?.workspace?.failed?.totalCount,
  };
}

const query = gql`
  query CompletedImportsPage($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      workspaceId
      ...ImportTabbedMenu
    }
  }
  ${ImportTabbedMenu.fragment}
`;
